const get_tencrypt_key = () => {
  const sources = [
    import.meta.env.TENCRYPT,
    window?.process?.env?.TENCRYPT,
    window?.process?.env?.VUE_APP_TENCRYPT,
    window.TENCRYPT,
    window.VUE_APP_TENCRYPT
  ];

  const key = sources.find(Boolean);
  
  if (!key) {
    console.warn('TENCRYPT_KEY no encontrada. Verifica la configuración de variables de entorno.');
    return null;
  }

  return key;
};

export { get_tencrypt_key };
export default get_tencrypt_key;
